import { Component, Input, inject } from '@angular/core';
import { combineLatest, Observable, map } from 'rxjs';
import { PayeeCasesService } from '../payee-cases.service';
import { TaskRecipient } from '../types';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

type CaseQuickFilter = 'all' | 'todo' | 'notary_late';

@Component({
  selector: 'payee-case-quick-filters',
  templateUrl: './case-quick-filters.component.html',
  styleUrls: ['./case-quick-filters.component.scss'],
  imports: [PayeeButtonComponent, AsyncPipe, TranslateModule],
})
export class CaseQuickFiltersComponent {
  private payeeCasesService = inject(PayeeCasesService);

  @Input() showTodoSubTabs = false;
  @Input() showNotaryLateFilter = false;

  get options(): CaseQuickFilter[] {
    return this.showNotaryLateFilter
      ? ['all', 'todo', 'notary_late']
      : ['all', 'todo'];
  }

  readonly todoSubTabOptions: TaskRecipient[] = ['ADMIN', 'ATTORNEY'];

  readonly selectedOption$: Observable<CaseQuickFilter>;
  readonly selectedTodoSubTab$: Observable<TaskRecipient>;

  constructor() {
    this.selectedOption$ = combineLatest([
      this.payeeCasesService.has_task,
      this.payeeCasesService.is_notary_late,
    ]).pipe(
      map(([hasTask, isNotaryLate]) => {
        if (isNotaryLate === 1) {
          return 'notary_late';
        }

        return hasTask === 1 ? 'todo' : 'all';
      }),
    );

    this.selectedTodoSubTab$ = combineLatest([
      this.payeeCasesService.has_task,
      this.payeeCasesService.task_recipient,
    ]).pipe(
      map(([hasTask, taskRecipient]) => {
        if (hasTask !== 1) {
          return 'ADMIN';
        }

        return taskRecipient ?? 'ADMIN';
      }),
    );
  }

  selectOption(option: CaseQuickFilter): void {
    this.payeeCasesService.has_task.next(option === 'todo' ? 1 : null);
    this.payeeCasesService.is_notary_late.next(option === 'notary_late' ? 1 : null);

    if (option === 'todo') {
      if (
        this.showTodoSubTabs &&
        !this.payeeCasesService.task_recipient.value
      ) {
        this.payeeCasesService.task_recipient.next('ADMIN');
      }
      return;
    }

    this.payeeCasesService.task_recipient.next(null);
  }

  selectTodoSubTab(option: TaskRecipient): void {
    this.payeeCasesService.task_recipient.next(option);
  }
}
